import herald_header_check from "../functions/herald_header_check";
import herald_sticky_sidebar from "../functions/herald_sticky_sidebar";
import herald_sidebar_switch from "../functions/herald_sidebar_switch";
import herald_sticky_meta_bar from "../functions/herald_sticky_meta_bar";
import herald_responsive_header_ad from "../functions/herald_responsive_header_ad";

export default function () {
  $(window).resize(function () {

    // Don't do anything in full screen mode
    if (document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement) {
      return;
    }

    herald_header_check();
    herald_sticky_sidebar();
    herald_sidebar_switch();
    herald_sticky_meta_bar();
    herald_responsive_header_ad();

    $('.herald-responsive-header .herald-menu-popup-search.herald-search-active span').removeClass('fa-times').addClass('fa-search');
    $('.herald-responsive-header .herald-menu-popup-search .herald-in-popup').removeClass('herald-search-active');
  });
}
